import { render, staticRenderFns } from "./DbGisSettings.vue?vue&type=template&id=146c2c65&scoped=true&"
import script from "./DbGisSettings.vue?vue&type=script&lang=js&"
export * from "./DbGisSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c2c65",
  null
  
)

export default component.exports